import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { signOut } from '../../../store/actions/auth/authActions'
import firebase from 'firebase'
import {MDBNavItem,MDBNavLink,MDBDropdown,MDBDropdownToggle,MDBIcon,MDBDropdownItem,MDBDropdownMenu} from 'mdbreact'

const SignedInLinks = (props) => {
   

 
 
    return (
        
        <MDBNavItem>
        <MDBDropdown>
        <MDBDropdownToggle className="dopdown-toggle" nav caret>
        <MDBIcon icon="user" />
                </MDBDropdownToggle>
          <MDBDropdownMenu className="dropdown-default">
          <MDBNavLink  className="nav-link black-text" to={" "} onClick={props.signOut}>signout</MDBNavLink>
          <MDBNavLink  className="nav-link black-text" to="/dashboard">Dashboard</MDBNavLink>
          </MDBDropdownMenu>
        </MDBDropdown>
      </MDBNavItem>

    )
}

const mapDispatchToProps = (dispatch) =>{
  return {
      signOut: () => dispatch(signOut())
  }
}

export default connect(null, mapDispatchToProps)(SignedInLinks);